import { TitleCasePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatOption } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';
import Swal from 'sweetalert2'
import { ScreeningUtilityService } from '../screening-utility-service';
import { AlertService } from 'src/app/_services/alert.service';

@Component({
  selector: 'app-screening-configuration',
  templateUrl: './screening-configuration.component.html',
  styleUrls: ['./screening-configuration.component.scss']
})
export class ScreeningConfigurationComponent implements OnInit {

  sliderValue : any = 0;
  sliderValueTemp : any = 0;
  searchListDropdown : any[];
  searchListDigiDropdown : any[];
  finalSearchList : any[];
  finalSearchListDigi : any[];
  userType: any;
  aliasCheck : boolean;
  rcaCheck : boolean;
  allSelected=false;
  
  @ViewChild('select') select: MatSelect;

  constructor(private apiService : ScreeningUtilityService,private alertService : AlertService) { }

  ngOnInit(): void {
    this.finalSearchList = [];
    // this.searchListDropdown = ["sanction", "warning", "fitness-probity", "pep", "pep-class-1", "pep-class-2", "pep-class-3", "pep-class-4","Special Intrest Person (SIP)", "Special Intrest Entity (SIE)", "Insolvency"];
    this.searchListDropdown = [{ key: "sanction", title: "Sanctions", isSelectedALL: 'ALL' },
      { key: "SIP", title: "(Special Interest Person) SIP", isSelectedALL: 'ALL' },
      { key: "SIE", title: "(Special Interest Entity) SIE", isSelectedALL: 'ALL' },
      { key: "warning", title: "Warnings", isSelectedALL: 'ALL' },
      { key: "Insolvency", title: "Insolvency", isSelectedALL: 'ALL' },
      { key: "fitness-probity", title: "Fitness-Probity", isSelectedALL: 'ALL' },
      { key: "pep", title: "PEP", isSelectedALL: 'ALL' },
      { key: "pep-class-1", title: "PEP-Class-1", isSelectedALL: 'ALL' },
      { key: "pep-class-2", title: "PEP-Class-2", isSelectedALL: 'ALL' },
      { key: "pep-class-3", title: "PEP-Class-3", isSelectedALL: 'ALL' },
      { key: "pep-class-4", title: "PEP-Class-4", isSelectedALL: 'ALL' },
      { key: "adverse-media", title: "Adverse-Media", isSelectedALL: 'ALL' }];

      this.searchListDigiDropdown = [{ key: "PEP", title: "PEP", isSelectedALL: 'ALL' },
      { key: "POI", title: "POI", isSelectedALL: 'ALL' },
      { key: "REL", title: "REL", isSelectedALL: 'ALL' },
      { key: "RRE", title: "RRE", isSelectedALL: 'ALL' },
      { key: "INS", title: "INS", isSelectedALL: 'ALL' }];

    console.log(this.userType);
  }

  getTypeData(userType:any){
    console.log(userType);
    if(userType == undefined){
      return;
    }
    this.apiService.getUserTypeData(userType).subscribe((response:any)=>{
      console.log(response);
      if(response.response.data != null){
        this.finalSearchList = response.response.data.searchList;
        this.finalSearchListDigi = response.response.data.searchListDigi;
        this.sliderValueTemp = response.response.data.matchScore;
        this.sliderValue = response.response.data.matchScore;
        this.aliasCheck = response.response.data.aliasSearch;
        this.rcaCheck = response.response.data.rcaSearch;
      }else{
        this.alertService.errorAlertWithMessage("Data not found")
      }
    })
  }

  valueChanged(event: any){
    console.log(event);
    this.sliderValue = event.target.value; 
    this.sliderValueTemp = event.target.value; 
  }

  // inputChange(event : any){
  //   if(event.target.value == ""){
  //     console.log(event.target.value);
  //     this.sliderValueTemp = 0;
  //     return;
  //   }
  //   if(Number(event.target.value) <= 100){
  //   console.log(event.target.value);
  //   this.sliderValueTemp = event.target.value;
  //   return;
  //   }else if(Number(event.target.value) > 100){
  //     console.log(event.target.value);
  //     this.sliderValueTemp = 0;
  //     this.sliderValue = 0;
  //     console.log(this.sliderValue);
  //     return;
  //   }

  // }

  inputChange(event: any) {
    if (event.target.value == "") {
      console.log(event.target.value);
      this.sliderValueTemp = 0;
      return;
    }
    if (Number(event.target.value) <= 100) {
      console.log(event.target.value);
      this.sliderValue = event.target.value;
      this.sliderValueTemp = event.target.value;
      return;
    } else if (Number(event.target.value) > 100) {
      console.log(event.target.value);
      this.sliderValueTemp = 0;
      this.sliderValue = 0;
      console.log(this.sliderValue);
      return;
    }

  }

  removeSearchName(event :any){
    // console.log(event);
    // this.finalSearchList.slice(event.index,1);
    // console.log(this.finalSearchList);
  }

  addSearchName(event :any){
    // console.log(event);
    // this.finalSearchList.push(event.key);
    // console.log(this.finalSearchList);
  }


  selectAll() {
		this.finalSearchList = this.searchListDropdown;
	}

	unselectAll() {
		this.finalSearchList = [];
	}

  saveConfiguration(){
    console.log(this.userType);
    console.log(this.finalSearchList);
    console.log(this.sliderValue);
    console.log(this.sliderValueTemp);
    console.log(this.aliasCheck);
    console.log(this.rcaCheck);
    if (this.finalSearchList.length == 0) {
      this.alertService.toastWarringMessageAlertWithMessage("Please select search list");
      return;
    }
    if (this.sliderValue > 100) {
      this.alertService.toastWarringMessageAlertWithMessage("Please set match score below 100");
      return;
    }
    if (this.sliderValue <= 0) {
      this.alertService.toastWarringMessageAlertWithMessage("Please set match score above 0");
      return;
    }
    if (this.finalSearchListDigi.length == 0) {
      this.alertService.toastWarringMessageAlertWithMessage("Please select search list for Digi");
      return;
    }
    let requestBody : any = {
      "userType": this.userType,
      "matchScore": this.sliderValue,
      "aliasSearch": this.aliasCheck,
      "rcaSearch": this.rcaCheck,
      "searchList": this.finalSearchList,
      "searchListDigi": this.finalSearchListDigi,
    }
    this.apiService.updateUserTypeData(requestBody).subscribe((response:any)=>{
      console.log(response);
      if(response.response.status == 200){
        Swal.fire(response.response.message,'','success');
      }else{
        Swal.fire('Error while updating the configuration','','error');
      }
    })
    // Swal.fire('Error while updating the configuration','','error');
  }
}
